import applySmartCrop from 'helpers/applySmartCrop';
import {
  PROFILE_SUMMARY_THUMBNAIL_SIZE_DESKTOP,
  PROFILE_SUMMARY_THUMBNAIL_SIZE_MOBILE,
} from 'constants/Profiles';
import { FALLBACK_SEARCH_THUMBNAIL_URL } from 'constants/Search';

const getProfileFeedbackHeroImages = url => ({
  desktop:
    applySmartCrop(
      url,
      PROFILE_SUMMARY_THUMBNAIL_SIZE_DESKTOP,
      PROFILE_SUMMARY_THUMBNAIL_SIZE_DESKTOP
    ) || FALLBACK_SEARCH_THUMBNAIL_URL,
  mobile: applySmartCrop(
    url,
    PROFILE_SUMMARY_THUMBNAIL_SIZE_MOBILE,
    PROFILE_SUMMARY_THUMBNAIL_SIZE_MOBILE
  ),
});

export default getProfileFeedbackHeroImages;
